<template>
  <div id="app">
    <div v-if="loading" id="page-loader" class="pulsing">
      <div class="loader-name">
        <img src="./assets/logo.svg" alt="一兮生物" />
      </div>
      <div class="loader-circle">
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 253.4 253.4"
          style="enable-background: new 0 0 253.4 253.4"
          xml:space="preserve"
        >
          <circle cx="126.7" cy="126.7" r="124.2"></circle>
        </svg>
      </div>
    </div>
    <YXHeader></YXHeader>
    <router-view />
    <YXFooter></YXFooter>
  </div>
</template>

<script>
export default {
  name: "App",
  watch: {
    $route: function(to, from) {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  },
  data() {
    return {
      loading: true,
      imgs: []
    };
  },
  beforeCreate() {
    this.loading = true;
    /**@判断需要加入哪些资源 */
    switch (location.pathname) {
      case "": //首页
      case "/":
        this.imgs = [
          require("./assets/main/aboutUs.png"),
          require("./assets/main/advantage1.png"),
          require("./assets/main/advantage2.png"),
          require("./assets/main/bg.png"),
          require("./assets/main/industrial.png")
        ];
        break;
      case "/tech": //技术优势
      case "/tech/":
        this.imgs = [
          require("./assets/tech/advantage1.png"),
          require("./assets/tech/advantage2.png"),
          require("./assets/tech/banner.png")
        ];
        break;
      case "/product": //产品与服务
      case "/product/":
        this.imgs = [
          require("./assets/industrial/banner.png"),
          require("./assets/industrial/industrial1.png"),
          require("./assets/industrial/industrial2.png")
        ];
        break;
      case "/about": //关于一兮
      case "/about/":
        this.imgs = [
          require("./assets/about/about2.png"),
          require("./assets/about/lap01.png"),
          require("./assets/about/lap02.png"),
          require("./assets/about/lap03.png"),
          require("./assets/about/lap04.png")
        ];
        break;
      case "/news": //公司动态
      case "/news/":
        this.imgs = [require("./assets/news/news1.png")];
        break;
      case "/join": //加入我们
      case "/join/":
        this.imgs = [require("./assets/join/join1.png")];
        break;
      case "/hmo": //HMO
      case "/hmo/":
        this.imgs = [
          require("./assets/hmo/hmo1.png"),
          require("./assets/hmo/hmo2.png"),
          require("./assets/hmo/hmo3.png"),
          require("./assets/hmo/hmo4.png"),
          require("./assets/hmo/hmo5.png")
        ];
      case "/newsDetail": //新闻详情
      case "/newsDetail/":
        this.imgs = [];
        break;
      default:
        break;
    }
    /**@添加固定的资源 */
    this.imgs = this.imgs.concat([require("./assets/logo.svg")]);
    /**@资源的总长度 */
    const total = this.imgs.length;
    let count = 0;
    for (let img of this.imgs) {
      let image = new Image();
      image.onload = res => {
        count++;
        if (count == total) {
          this.loading = false;
        }
      };
      image.src = img;
    }
  },
  mounted() {}
};
</script>

<style>
#app {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue